export enum DISCLAIMERS {
  VERIFYING_SALES_ACCOUNTS = '*Subject to change upon verifying sales accounts',
  UNDERSTANDING_CAPACITY_LINK = 'https://help.clear.co/s/article/Understanding-Capacity',
  UNDERSTANDING_ROLLING_CAPACITY_LINK = 'https://help.clear.co/s/article/Understanding-Rolling-Funding',
  PRELIMINARY_CAPACITY = '* Subject to change, please submit an invoice or cash advance to receive your Approved Funding Capacity. Terms and conditions apply.',
  APPROVED_CAPACITY = '* Available Funding Capacity, including pending invoices and/or cash advances. Terms and conditions apply.',
}

export enum STRATEGY_TYPES {
  static_origination = 'static_origination',
  prorata_origination = 'prorata_origination',
  static_origination_v2 = 'static_origination_v2',
}

export enum CAPACITY_TYPES {
  funding = 'Funding',
  rolling_funding = 'Rolling Funding',
  fixed_funding = 'Fixed Funding',
}

export enum CAPACITY_STATUSES {
  approved = 'Approved',
  preliminary = 'Preliminary',
  self_reported = 'Self-Reported',
}

export enum CAPACITY_APPROVAL_VALIDITY_DAYS {
  fixed_funding = 30,
  rolling_funding = 90,
}

export const MINIMUM_CAPACITY_CENTS_FOR_ROLLING_FUNDING = 20000000; // $200,000
